import React from "react";


const ProgramCommittee = () => (
        <section id="/team/#pc" style={{ paddingTop: "4rem" }}>
                <h3 className="title is-3">Program Committee</h3>

            <ul className="custom-list">
                <li>Amir M. Rahmani, University of California, Irvine, USA</li>
                <li>Ali Rostami, University of California, Irvine, USA</li>
                <li>Parham Moradi, RMIT University, Australia</li>
                <li>Ali Vardasbi, Spotify, Netherlands</li>
                <li>Seyed Mohssen Ghafari, Commonwealth Bank of Australia, Macquarie University, Sydney, Australia</li>
                <li>Kapil Kumar Reddy Poreddy, Walmart Global Tech, USA</li>
                <li>Venktesh Viswanathan, Delft University, Netherlands</li>
                <li>Hosseinali Rahmani Dashti, University College London, UK</li>
                <li>Jarkko Saarinen, University of Oulu, Finland</li>
                <li>Pantea Keikhosrokiani, University of Oulu, Finland</li>
                <li>Djamal BENSLIMANE, Lyon 1 University, France</li>
                <li>Puneet Kumar, University of Oulu, Finland</li>
                <li>Siamak Seyfi, University of Oulu, Finland</li>
                <li>Ashutosh Agarwal, Stevens Institute of Technology, USA</li>
                <li>Anika, Gautam Buddha University, India</li>
                <li>Yanming Liu, Zhejiang University, China</li>
            </ul>


        </section>
);

export default ProgramCommittee;
